import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import {
     MerchantEditWithoutLogin,MerchantApplicationWithoutLogin, MerchantApplicationAcceptance
} from './components';
import { EntryActions, NotificationActions } from '../../store';

const style = theme => ({
    root: {
        height: '100%'
    },
    visibleList: {
        height: '100%',
        visibility: 'visible'
    },
    hiddenList: {
        height: '100%',
        visibility: 'hidden'
    },
})

const merchantsSelector = (state) => state.Merchants;
const IdentitySelector = (state) => state.Identity;

const Entry = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const entryActions = bindActionCreators(EntryActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, code, nowWainting } = useSelector(merchantsSelector);
    // useSelector で store の state を取得。
    const { token } = useSelector(IdentitySelector);

    const [mode, setMode] = useState('edit');
    const [listRefresh, setListRefresh] = useState(true);
    const [index, setIndex] = useState(0);
    const [data, setData] = useState({});
    const { classes } = props;

    
    /**
    *
    * 申込入力画面
    *
    * @param data 選択された行のデータ
    */
    const showEdit = () => {
        setMode('edit');
    }

    /**
     *
     * 申込内容確認
     *
     * @param data 選択された行のデータ
     */
    const showConfirm = (data) => {
        setMode('confirm');
    }

    /**
     *
     * 申込登録完了
     *
     */
    const showComplete = () => {
        setMode('complete');
    }

    var listClass = classes.hiddenList;

    // 申込登録
    if (mode == 'edit') {
        if (editing == null) {
            entryActions.loadEditModel(token, null)
                .then(data => {
                })
                .catch(e => {
                    notificationActions.showError('新規申請データを作成できませんでした。');
                });
        }
        listClass = classes.visibleList;
    }

    var content = <div></div>;

     // 申込内容確認
    if (mode == 'confirm') {
        content = <MerchantApplicationWithoutLogin onComplete={showComplete} onCancel={showEdit} />
    }

     // 申込完了
    if (mode == 'complete') {
        content = <MerchantApplicationAcceptance />
    }

    return (
        <div className={classes.root}>
            {content}
            <div className={listClass}>
                <MerchantEditWithoutLogin onConfirm={showConfirm} refresh={listRefresh} />
            </div>
        </div>
    )

}

export default withStyles(style, { withTheme: true })(Entry);
